import api from "../api/axios";

import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";
import {
  UpdateDeploymentSitePayload,
  CreateDeploymentSitePayload,
} from "../Types/CompanyProfile/DeploymentSite";

export const DEPSITE_QUERY_KEY = ["deployment-site"];
export const VIEW_DEPSITE_QUERY_KEY = ["view-deployment-site"];

export const deploymentsiteService = {
  createDeploymentSite: async (payload: CreateDeploymentSitePayload) => {
    const response = await api.post(`api/deployment-site`, payload);
    return response.data;
  },
  updateDeploymentSite: async (
    id: number,
    payload: UpdateDeploymentSitePayload,
  ) => {
    const response = await api.patch(`api/deployment-site/${id}`, payload);
    return response.data;
  },
  toggleStatus: async (id: number) =>
    requestWithRefresh(() =>
      api
        .patch(`api/deployment-site/${id}/toggle-status`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),
  getAllViewDeploymentSiteByCompany: async (company_code: string) =>
    requestWithRefresh(() =>
      api
        .get(`api/view-deployment-site?company_code=${company_code}`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data.data),
    ),
  getAllViewDeploymentSiteByCluster: async (
    company_code: string,
    region_id: Number,
    cluster_id: Number,
  ) =>
    requestWithRefresh(() =>
      api
        .get(
          `api/view-deployment-site?company_code=${company_code}&region_id=${region_id}&cluster_id=${cluster_id}`,
          {
            headers: getAuthHeaders(),
          },
        )
        .then((res) => res.data.data),
    ),
  getViewDeploymentSiteById: async (id: number) =>
    requestWithRefresh(() =>
      api
        .get(`api/view-deployment-site/${id}`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data.data),
    ),
};
